// extracted by mini-css-extract-plugin
export default {"input":"Input_input__siM7z","delete":"Input_delete__KnQL6","removable":"Input_removable__uxpUq"};